import Axios from 'axios';
import qs from 'qs';
import { CHANGE_REPLENISHLABEL, FETCH_CONSIGNMENTS_CUSTOMER_COUNT_REPLENISH_DETAIL, FETCH_CONSIGNMENTS_CUSTOMER_COUNT_NO_REPLENISH_CUST, CONSIGNMENTS_CUSTOMER_INVENTORY_REPLENISH_CHANGE, FETCH_CONSIGNMENTS_CUSTOMER_COUNT_REPLENISH, FETCH_ALL_THIRD_PARTY_PERMISSIONS, FETCH_USER_THIRD_PARTY_PERMISSIONS, FETCH_CONSIGNMENTS_CUSTOMER, FETCH_CONSIGNMENTS_CUSTOMER_COUNTEDIT, CONSIGNMENTS_CUSTOMER_INVENTORY_ONHAND, FETCH_CONSIGNMENTS_CUSTOMER_INVENTORY, NOTICE_MESSAGE, FETCH_USER_CUSTOMER_PERMISSIONS, ADMIN_FETCH_USERS, ADD_CONSIGNMENT_POPUP, FETCH_USER_CONSIGNMENTS_CUSTOMER, FETCH_CONSIGNMENTS_PRODUCT, FETCH_DELETE_ROW, FETCH_EDIT_ROW, FETCH_INSERT_ITEMS_ROW, HAS_ERRORS} from './actionTypes'
import { BASEURL2, HEADERS, HEADERS_JSON } from './index';

const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    //'Access-Control-Allow-Origin': '*'
}

const headersJSON = {
    'Content-Type': 'application/json',
    // 'Access-Control-Allow-Origin': '*'
}

export const setAddConsignmentPopup = (rowState) => {

    return async (dispatch) => {
        try{
            // console.log('consignmentsPostActions setAddConsignmentPopup rowState', rowState)
        
            dispatch({                    
                type: ADD_CONSIGNMENT_POPUP,   
                payload: rowState
            })                      
        } catch (error){
            console.log('consignmentsPostActions setAddConsignmentPopup failed error: ' + error)           
        }  
    }
};

export const setCustomerInventoryOnhand = (rowState) => {

    return async (dispatch) => {
        try{
            // console.log('consignmentsPostActions setCustomerInventoryOnhand rowState', rowState)
        
            dispatch({                    
                type: CONSIGNMENTS_CUSTOMER_INVENTORY_ONHAND,   
                payload: rowState
            })                      
        } catch (error){
            console.log('consignmentsPostActions setCustomerInventoryOnhand failed error: ' + error)           
        }  
    }
};

export const submitConsignmentsCustomerInventoryCount = (userid, custid, comments, consignmentsCustInventoryOnhandState) => {
    
    const param = {'USERID': userid, 'CUSTID': custid, 'COMMENTS': comments, 'INPUTDATA': consignmentsCustInventoryOnhandState}
    
    return async (dispatch) => {
        try{
            const res = await Axios.post(`${BASEURL2}/submitConsignmentsCustomerInventoryCount`,  qs.stringify(param, { indices: false }), { HEADERS });

            const { data } = res;
            if(typeof(data['ERROR']) !== 'undefined'){
                alert(data['ERROR']);                      
            }
            else{    
                alert(data['message']);

                const countedPrdidList = Object.keys(consignmentsCustInventoryOnhandState[custid]);
                fetchConsignmentsCustomerCountReplenish(custid, countedPrdidList)(dispatch);                 
            }  

        } catch (error){
            console.log('consignmentsPostActions submitConsignmentsCustomerInventoryCount error: ' + error)
            alert('ERROR Submitting Consignment Inventory Count: ' + error);                     
        }  
    }
};



export const fetchConsignmentsCustomerCountReplenish = (custid, countedPrdidList) => {
    return async (dispatch) => {
        try{
            const custidParam = {custidInput: custid};
            const countedPrdidListParam = {countedPrdidListInput: countedPrdidList};
            const param = {...custidParam, ...countedPrdidListParam}

            const res = await Axios.post(`${BASEURL2}/fetchConsignmentsCustomerCountReplenish`,  qs.stringify(param, { comma: true }), { HEADERS });

            const { data } = res;

            if(typeof(data['NOTICE']) !== 'undefined'){
                dispatch({                    
                    type: FETCH_CONSIGNMENTS_CUSTOMER_COUNT_NO_REPLENISH_CUST,   
                    payload: data['NOTICE']
                })
            }            
            else if(typeof(data['message']['SUMMARY']) !== 'undefined'){
                dispatch({                    
                    type: FETCH_CONSIGNMENTS_CUSTOMER_COUNT_REPLENISH,   
                    payload: data['message']['SUMMARY']
                })

                if(typeof(data['message']['DETAIL']) !== 'undefined'){
                    dispatch({                    
                        type: FETCH_CONSIGNMENTS_CUSTOMER_COUNT_REPLENISH_DETAIL,   
                        payload: data['message']['DETAIL']
                    })      
                }          
            }else{
                dispatch({                    
                    type: HAS_ERRORS,   
                    payload: 'unable to retrieve consignment customers replenish'
                })                   
                console.log('consignmentsPostActions fetchConsignmentsCustomerCountReplenish unable to retrieve')
            }                        
        } catch (error){
            console.log('consignmentsPostActions fetchConsignmentsCustomerCountReplenish failed : ' + error)
            dispatch({                    
                type: HAS_ERRORS,   
                payload: error.toString() //error.response.data.message
            })                  
        }  
    }
};

export const submitConsignmentsCustomerInventoryReplenish = (userid, custid, comments, po, consignmentsCustInventoryCountReplenishDetailState) => {
    
    const param = {'USERID': userid, 'CUSTID': custid, 'COMMENTS': comments, 'PO': po, 'ORDERING_LOCS': []}    
    
    return async (dispatch) => {
        try{
            if(po.trim() === ''){
                alert('Please enter in PO field before submitting.')
            }
            else{
                let replenishParam = {}

                for (const [key, value] of Object.entries(consignmentsCustInventoryCountReplenishDetailState)) {                  
                    value.map(element => {
                        console.log('element',element)

                        if(element['LOC_REPLENISH_QTY'] <= 0){
                            
                        }
                        else{
                            if(!(element['ORDERING_LOC'] in replenishParam)) {
                                replenishParam[element['ORDERING_LOC']] = [];
                                param['ORDERING_LOCS'].push(element['ORDERING_LOC'])
                            }
                            
                            replenishParam[element['ORDERING_LOC']].push([element['PRDID'], element['LOC_REPLENISH_QTY']]) 
                            
                        }

                    })   

                }
                console.log('replenishParam',replenishParam)

                const submitState = {...param, ...replenishParam}

                const res = await Axios.post(`${BASEURL2}/submitConsignmentsCustomerInventoryReplenish`,  
                    submitState, 
                    { 
                        headers: { 
                            'Content-Type': "application/json" 
                        }                    
                    }
                );
                

                const { data } = res;

                if(typeof(data['ERROR']) !== 'undefined'){
                    alert(data['ERROR']);                      
                }
                else{    
                    alert(data['message']);                                         
                    window.location.href='/'           
                }  
            }


        } catch (error){
            console.log('consignmentsPostActions submitConsignmentsCustomerInventoryCount error: ' + error)
            alert('ERROR Submitting Consignment Inventory Count: ' + error);                     
        }  
    }
};

// export const setCustomerInventoryReplenishChange = (rowState) => {

//     return async (dispatch) => {
//         try{
//             // console.log('consignmentsPostActions setCustomerInventoryReplenishChange rowState', rowState)
        
//             dispatch({                    
//                 type: CONSIGNMENTS_CUSTOMER_INVENTORY_REPLENISH_CHANGE,   
//                 payload: rowState
//             })                      
//         } catch (error){
//             console.log('consignmentsPostActions setCustomerInventoryReplenishChange failed error: ' + error)           
//         }  
//     }
// };

export const resetNoticeMessage = (rowState) => {

    return async (dispatch) => {
        try{
            // console.log('consignmentsPostActions setAddConsignmentPopup rowState', rowState)
        
            dispatch({                    
                type: NOTICE_MESSAGE,   
                payload: ''
            })                      
        } catch (error){
            console.log('consignmentsPostActions setAddConsignmentPopup failed error: ' + error)           
        }  
    }
};

export const fetchInsertItemsRow = (rowState, addConsignmentPopup) => {

    return async (dispatch) => {
        try{
            console.log('consignmentsPostActions fetchInsertItemsRow rowState', rowState, 'addConsignmentPopup', addConsignmentPopup)
            
            // console.log('consignmentsPostActions fetchInsertItemsRow addConsignmentPopup.consignmentClickedDetails', addConsignmentPopup.consignmentClickedDetails)

            if(addConsignmentPopup.custnoClicked !== null && addConsignmentPopup.custnoClicked !== ''){
                rowState = {...rowState, 'CUSTNO': addConsignmentPopup.custnoClicked}
            }
            
            if(addConsignmentPopup.custnoClicked !== null && addConsignmentPopup.partnoClicked !== ''){
                // rowState = {...rowState, 'PARTNO': addConsignmentPopup.partnoClicked}
                rowState = {...rowState, 'PARTNO': rowState.PARTNO}
            
            }

            const res = await Axios.post(`${BASEURL2}/insert_itemsRow`,  qs.stringify(rowState, { indices: false }), { HEADERS });

            const { data } = res;
           
            // console.log('consignmentsPostActions fetchInsertItemsRow data', data)

            if(typeof(data['ERROR']) !== 'undefined'){
                alert(data['ERROR']);                      
            }
            else if(typeof(data['notice']) !== 'undefined'){
                dispatch({                    
                    type: NOTICE_MESSAGE,   
                    payload: data['notice']
                })
            }
            else{    
                alert(data['message'][0]);

                //update table
                // let newConsignmentsCustState = [...consignmentsCustState]
                // newConsignmentsCustState.append({...rowState})
                
                fetchConsignmentsCustomer({custnoInput: addConsignmentPopup.custnoClicked})(dispatch);

                setAddConsignmentPopup({
                    showModel:null,
                    custnoClicked:addConsignmentPopup.custnoClicked,
                    custClickedDetails: addConsignmentPopup.custClickedDetails,
                    consignmentClickedDetails: []
                })(dispatch);

                // dispatch({                    
                //     type: FETCH_INSERT_ITEMS_ROW,   
                //     payload: newConsignmentsCustState  //update State/tbl Data
                // })


                // console.log('consignmentsPostActions fetchInsertItemsRow retrieved')
            }                      
        } catch (error){
            console.log('consignmentsPostActions fetchInsertItemsRow failed error: ' + error)

            alert('ERROR Editing Consignment Item: ' + error);          
        }  
    }
};

export const fetchEditItemsRow = (rowState, addConsignmentPopup) => {

    return async (dispatch) => {
        try{
            // console.log('consignmentsPostActions fetchEditItemsRow rowState', rowState, 'addConsignmentPopup', addConsignmentPopup)
            
            if(addConsignmentPopup.custnoClicked !== null && addConsignmentPopup.custnoClicked !== ''){
                rowState = {...rowState, 'CUSTNO': addConsignmentPopup.custnoClicked}
            }
            
            if(addConsignmentPopup.custnoClicked !== null && addConsignmentPopup.partnoClicked !== ''){
                rowState = {...rowState, 'PARTNO': addConsignmentPopup.partnoClicked}
            }

            const res = await Axios.post(`${BASEURL2}/edit_itemsRow`,  qs.stringify(rowState, { indices: false }), { HEADERS });

            const { data } = res;
           
            // console.log('consignmentsPostActions fetchEditItemsRow data', data)

            if(typeof(data['ERROR']) !== 'undefined'){
                alert(data['ERROR']);                      
            }
            else{    
                alert(data['message'][0]);
                
                fetchConsignmentsCustomer({custnoInput: addConsignmentPopup.custnoClicked})(dispatch);

                setAddConsignmentPopup({
                    showModel:null,
                    custnoClicked:addConsignmentPopup.custnoClicked,
                    custClickedDetails: addConsignmentPopup.custClickedDetails,
                    consignmentClickedDetails: []
                })(dispatch);


                // console.log('consignmentsPostActions fetchEditItemsRow retrieved')
            }                      
        } catch (error){
            console.log('consignmentsPostActions fetchInsertItemsRow failed error: ' + error)

            alert('ERROR Editing Consignment Item: ' + error);          
        }  
    }
};

export const fetchEditItemsRowOLD = (rowState, newConsignmentsCustState) => {
    return async (dispatch) => {
        try{
            const res = await Axios.post(`${BASEURL2}/edit_itemsRow`, qs.stringify(rowState, { indices: false }), { headers });
            const { data } = res;
           
            // console.log('consignmentsPostActions fetchEditItemsRow data: ' + JSON.stringify(data['message']));
            if(typeof(data['ERROR']) !== 'undefined'){

                dispatch({                    
                    type: HAS_ERRORS,   
                    payload: data['ERROR'] 
                })                         
            }
            else{ //(typeof(data['message']) !== 'undefined'){     

  

                dispatch({                    
                    type: FETCH_EDIT_ROW,   
                    payload: newConsignmentsCustState  //update State/tbl Data
                })

                // //TESTING
                // let testErrorHandler = { 
                //     hasError: false,
                //     message: "THIS IS A TEST ERROR HANDLER MSG RESPONSE"
                // };   

                // dispatch({                    
                //     type: HAS_ERRORS,   
                //     payload: testErrorHandler  //update State/tbl Data
                // })   

            }                      
        } catch (error){
            console.log('consignmentsPostActions fetchEditItemsRow failed error: ' + error)

            dispatch({                    
                type: HAS_ERRORS,   
                payload: error.toString() //error.response.data.message
            })                          
        }  
    }
};

export const fetchDeleteItemsRow = (rowState, newConsignmentsCustState) => {

    return async (dispatch) => {
        try{
            const res = await Axios.post(`${BASEURL2}/delete_itemsRow`, qs.stringify(rowState, { indices: false }), { headers });
            const { data } = res;
           
            if(typeof(data['message']) !== 'undefined'){     
                dispatch({                    
                    type: FETCH_DELETE_ROW,   
                    payload: newConsignmentsCustState  //update State/tbl Data
                })
            }else{
                //TODO: payload add data['error']
                dispatch({                    
                    type: HAS_ERRORS,   
                    payload: 'unable to delete'
                })                   
                console.log('consignmentsPostActions fetchDeleteItemsRow unable to retrieve')
            }                        
        } catch (error){
            console.log('consignmentsPostActions fetchDeleteItemsRow failed: ' + error)
            dispatch({                    
                type: HAS_ERRORS,   
                payload: error.toString() //error.response.data.message
            })           
        }  
    }
};

export const fetchConsignmentsCustomer = (custnoState, showInventoryOnly=false, showInventoryCountEdit=false) => {
    return async (dispatch) => {
        try{
            const res = await Axios.post(`${BASEURL2}/fetchConsignmentsCustomer`,  qs.stringify(custnoState, { comma: true }), { HEADERS });

            const { data } = res;
            if(typeof(data['message']) !== 'undefined'){

                if(showInventoryOnly){
                    dispatch({                    
                        type: FETCH_CONSIGNMENTS_CUSTOMER_INVENTORY,   
                        payload: data['message']
                    }) 
                }
                else if(showInventoryCountEdit){
                    dispatch({                    
                        type: FETCH_CONSIGNMENTS_CUSTOMER_COUNTEDIT,   
                        payload: data['message']
                    }) 
                }             
                else{
                    dispatch({                    
                        type: FETCH_CONSIGNMENTS_CUSTOMER,   
                        payload: data['message']
                    })
                }
            }else{
                dispatch({                    
                    type: HAS_ERRORS,   
                    payload: 'unable to retrieve consignment customers'
                })                   
                console.log('consignmentsPostActions fetchConsignmentsCustomer unable to retrieve')
            }                        
        } catch (error){
            console.log('consignmentsPostActions fetchConsignmentsCustomer failed : ' + error)
            dispatch({                    
                type: HAS_ERRORS,   
                payload: error.toString() //error.response.data.message
            })                  
        }  
    }
};


export const fetchUserConsignmentsCustomers = (userid, userCustOnly=false) => {
    return async (dispatch) => {
        try{
            const useridData = {'userid': userid.toString(),'userCustOnly': userCustOnly} 

            const res = await Axios.post(`${BASEURL2}/fetchUserConsignmentsCustomers`,  qs.stringify(useridData, { comma: true }), { headersJSON });

            const { data } = res;
            if(typeof(data['error']) === 'undefined' && typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0 ){
                dispatch({                    
                    type: FETCH_USER_CONSIGNMENTS_CUSTOMER,   
                    payload: data['message']
                })

                dispatch({                    
                    type: ADMIN_FETCH_USERS,   
                    payload: []
                })

            }else{
                var errResponse = 'unable to retrieve user consignment customers'
                if(typeof(data['error']) !== 'undefined'){
                    errResponse = data['error']
                } 
                console.log('consignmentsPostActions fetchUserConsignmentsCustomers errResponse:',errResponse)

                // dispatch({                    
                //     type: HAS_ERRORS,   
                //     payload: errResponse
                // }) 
                
                alert(errResponse)
            }                        
        } catch (error){
            console.log('consignmentsPostActions fetchUserConsignmentsCustomers failed : ' + error)
            // dispatch({                    
            //     type: HAS_ERRORS,   
            //     payload: error.toString() //error.response.data.message
            // })     
            
            alert(error.toString())
        }  
    }
};

export const fetchUserCustomersPermissions = (userid, userCustOnly=false) => {
    return async (dispatch) => {
        try{
            const useridData = {'userid': userid.toString()} 

            const res = await Axios.post(`${BASEURL2}/fetchUserCustomersPermissions`,  qs.stringify(useridData, { comma: true }), { headersJSON });

            const { data } = res;

            console.log('fetchUserCustomersPermissions data ', data);
            
            if(typeof(data['error']) === 'undefined' ){
                
                dispatch({                    
                    type: ADMIN_FETCH_USERS,   
                    payload: []
                })

                var responseData = []
                if(typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0){
                    responseData = data['message']
                }

                dispatch({                    
                    type: FETCH_USER_CUSTOMER_PERMISSIONS,   
                    payload: responseData
                })



            }else{
                var errResponse = 'unable to retrieve user customers'
                if(typeof(data['error']) !== 'undefined'){
                    errResponse = data['error']
                } 
                console.log('consignmentsPostActions fetchUserCustomersPermissions errResponse:',errResponse)

                dispatch({                    
                    type: HAS_ERRORS,   
                    payload: errResponse
                })                   
            }                        
        } catch (error){
            console.log('consignmentsPostActions fetchUserCustomersPermissions failed : ' + error)
            dispatch({                    
                type: HAS_ERRORS,   
                payload: error.toString() //error.response.data.message
            })                  
        }  
    }
};


export const fetchUserThirdPartyPermissions = (userid) => {
    return async (dispatch) => {
        try{
            const useridData = {'userid': userid.toString()} 

            const res = await Axios.post(`${BASEURL2}/fetchUserThirdPartyPermissions`,  qs.stringify(useridData, { comma: true }), { headersJSON });

            const { data } = res;

            console.log('fetchUserThirdPartyPermissions data ', data);
            
            if(typeof(data['error']) === 'undefined' ){
                
                dispatch({                    
                    type: ADMIN_FETCH_USERS,   
                    payload: []
                })

                var responseData = []
                if(typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0){
                    responseData = data['message']
                }

                dispatch({                    
                    type: FETCH_USER_THIRD_PARTY_PERMISSIONS,   
                    payload: responseData
                })

                var response2Data = []
                if(typeof(data['messageResponse2']) !== 'undefined' && Object.keys(data['messageResponse2']).length > 0){
                    response2Data = data['messageResponse2']
                }

                dispatch({                    
                    type: FETCH_ALL_THIRD_PARTY_PERMISSIONS,   
                    payload: response2Data
                })                


            }else{
                var errResponse = 'unable to retrieve user third party locs'
                if(typeof(data['error']) !== 'undefined'){
                    errResponse = data['error']
                } 
                console.log('consignmentsPostActions fetchUserThirdPartyPermissions errResponse:',errResponse)

                dispatch({                    
                    type: HAS_ERRORS,   
                    payload: errResponse
                })                   
            }                        
        } catch (error){
            console.log('consignmentsPostActions fetchUserThirdPartyPermissions failed : ' + error)
            dispatch({                    
                type: HAS_ERRORS,   
                payload: error.toString() //error.response.data.message
            })                  
        }  
    }
};

export const fetchConsignmentsProduct = () => dispatch => {
    try{
        Axios.post(`${BASEURL2}/products`).then( function(response){
            if( typeof(response.data.message) !== 'undefined' ){
                dispatch({                    
                    type: FETCH_CONSIGNMENTS_PRODUCT,   
                    payload: response.data.message['products']
                })
            }else{
                //TODO: payload add data['error']
                dispatch({                    
                    type: HAS_ERRORS,   
                    payload: 'unable to retrieve products list'
                })                  
                console.log('fetchConsignmentsProduct unable to retrieve')
            }            
        });


    } catch (error){
        console.log('fetchConsignmentsProduct failed : ' + error)
        dispatch({                    
            type: HAS_ERRORS,   
            payload: error.toString() //error.response.data.message
        })           
    }  
};

export const fetchManageUserAddCustomer = (userid, custnoInput) => {
    return async (dispatch) => {        
        try{
            const userInputData = {'userid': userid.toString(),'custnoInput': custnoInput} 

            const res = await Axios.post(`${BASEURL2}/manageUserAddCustomer`,  qs.stringify(userInputData, { comma: true }), { headersJSON });

            const { data } = res;
            //console.log('fetchManageUserAddCustomer data', data)

            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0 ){
                alert(data['message'])

                dispatch(fetchUserCustomersPermissions(userid))

            }else{
                var errResponse = 'Unable to add customer to user'

                if(typeof(data['ERROR']) !== 'undefined'){
                    errResponse = data['ERROR']
                } 
                console.log('consignmentsPostActions fetchManageUserAddCustomer errResponse:',errResponse)

                dispatch({                    
                    type: HAS_ERRORS,   
                    payload: errResponse
                })                   
            }    


        } catch (error){
            console.log('consignmentsPostActions fetchManageUserAddCustomer failed : ' + error)
            dispatch({                    
                type: HAS_ERRORS,   
                payload: error.toString() 
            })           
        }  
    }
};

export const fetchManageUserDeleteCustomer = (userid, custnoInput) => {
    return async (dispatch) => {        
        try{
            const userInputData = {'userid': userid.toString(),'custnoInput': custnoInput} 

            const res = await Axios.post(`${BASEURL2}/manageUserDeleteCustomer`,  qs.stringify(userInputData, { comma: true }), { headersJSON });

            const { data } = res;

            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0 ){
                alert(data['message'])

               dispatch(fetchUserCustomersPermissions(userid))

            }else{
                var errResponse = 'Unable to delete customer to user'

                if(typeof(data['ERROR']) !== 'undefined'){
                    errResponse = data['ERROR']
                } 
                console.log('consignmentsPostActions fetchManageUserDeleteCustomer errResponse:',errResponse)

                // dispatch({                    
                //     type: HAS_ERRORS,   
                //     payload: errResponse
                // })  
                
                alert(errResponse)
            }    


        } catch (error){
            console.log('consignmentsPostActions fetchManageUserDeleteCustomer failed : ' + error)
            // dispatch({                    
            //     type: HAS_ERRORS,   
            //     payload: error.toString() 
            // }) 
            
            alert(errResponse)
        }  
    }
};


export const fetchManageUserThirdPartyDeleteLoc = (userid, locInput) => {
    return async (dispatch) => {        
        try{
            const userInputData = {'userid': userid.toString(),'locInput': locInput} 

            const res = await Axios.post(`${BASEURL2}/manageUserThirdPartyDeleteLoc`,  qs.stringify(userInputData, { comma: true }), { headersJSON });

            const { data } = res;

            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0 ){
                alert(data['message'])

                dispatch(fetchUserThirdPartyPermissions(userid))

            }else{
                var errResponse = 'Unable to delete loc permission for user'

                if(typeof(data['ERROR']) !== 'undefined'){
                    errResponse = data['ERROR']
                } 
                console.log('consignmentsPostActions fetchManageUserThirdPartyDeleteLoc errResponse:',errResponse)
                
                alert(errResponse)
            }    


        } catch (error){
            console.log('consignmentsPostActions fetchManageUserThirdPartyDeleteLoc failed : ' + error)
            
            alert(errResponse)
        }  
    }
};

export const fetchManageUserThirdPartyEditLocPermission = (userid, locInput, permissionTypeInput) => {
    return async (dispatch) => {        
        try{
            const userInputData = {'userid': userid.toString(),'locInput': locInput, 'permissionTypeInput': permissionTypeInput} 

            const res = await Axios.post(`${BASEURL2}/manageUserThirdPartyEditLocPermission`,  qs.stringify(userInputData, { comma: true }), { headersJSON });

            const { data } = res;

            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0 ){
                alert(data['message'])

                dispatch(fetchUserThirdPartyPermissions(userid))

            }else{
                var errResponse = 'Unable to delete loc permission for user'

                if(typeof(data['ERROR']) !== 'undefined'){
                    errResponse = data['ERROR']
                } 
                console.log('consignmentsPostActions fetchManageUserThirdPartyEditLocPermission errResponse:',errResponse)
                
                alert(errResponse)
            }    


        } catch (error){
            console.log('consignmentsPostActions fetchManageUserThirdPartyEditLocPermission failed : ' + error)
            
            alert(errResponse)
        }  
    }
};

export const setChange_ReplenishLabel = (isShown) => {

    return async (dispatch) => {
        try{
            console.log('consignmentsPostActions setChange_ReplenishLabel isShown', isShown)
        
            dispatch({                    
                type: CONSIGNMENTS_CUSTOMER_INVENTORY_ONHAND,   
                payload: isShown
            })                      
        } catch (error){
            console.log('consignmentsPostActions setChange_ReplenishLabel failed error: ' + error)           
        }  
    }
};

export const setConsignmentsCustInventoryCountReplenishDetailState_locReplenishQty = (prevState, groupKey, index, newValue) => {
    return async (dispatch) => {
        try{
            const newState = { ...prevState }; 
            const newRows = [...newState[groupKey]]; 

            newRows[index] = { 
                ...newRows[index], 
                LOC_REPLENISH_QTY: newValue 
            };        

            newState[groupKey] = newRows;
           
            dispatch({                    
                type: FETCH_CONSIGNMENTS_CUSTOMER_COUNT_REPLENISH_DETAIL,   
                payload: newState
            })       

        } catch (error){
            console.log('consignmentsPostActions setConsignmentsCustInventoryCountReplenishDetailState_locReplenishQty failed error: ' + error)           
        }
    }      



};